import React, {Component} from "react";
import {connect} from "react-redux";
import AccountDetails from "./AccountDetails";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import {LIST_CUSTOMER_ACCOUNTS, ON_CUSTOMER_ACCOUNTS_UPDATED} from "../../queries/customers";

class AccountsList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, accountsForCustomer} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    return (
      <div>
         {this.renderAccounts(fromJS(accountsForCustomer))}
      </div>
    )
  }

  renderAccounts(accounts) {
    return accounts.map(x => {
      return (
        <AccountDetails
          key={x.get("accountId")}
          name={x.get("name")}
          accountId={x.get("accountId")}
          accountType=""
          vip={x.get("vip")}
          deleted={x.get("deleted")}
          onSelect={() => this.props.onSelectAccount(x.get("accountId"), x.get("store"))}
          selected={this.props.selectedAccountId === x.get("accountId")}
          onAddressClick={this.props.onEditShippingAddress}
          />
      )
    });
  }

}

AccountsList.defaultProps = {
  selectedAccountId: ""
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_CUSTOMER_ACCOUNTS_UPDATED,
      variables: {
        customerId: props.customerId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_CUSTOMER_ACCOUNTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      customerId: props.customerId
    }    
  })
})

export default withQuery(withSubscription(AccountsList));